import React from 'react'
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import styles from './GenericTooltip.module.scss'

const GenericTooltip = ({
  id,
  placement,
  text,
  textAlign,
  children,
  type,
  small = false,
  ...other
}) => {
  return (
    <OverlayTrigger
      placement={placement}
      overlay={
        <Tooltip
          className={classNames(styles.genericTooltip, styles[`text-${textAlign}`], {
            [styles.small]: small
          })}
          id={`tooltip-${id}`}
        >
          {text}
        </Tooltip>
      }
      {...other}
    >
      {({ ref, ...triggerHandler }) => (
        <Button variant="default" {...triggerHandler} className={styles.tooltipTrigger} ref={ref}>
          {children ? <span>{children}</span> : null}
          {type && (
            <span className={classNames(styles.iconContainer, type)}>
              <img src={`/images/icon-${type}.png`} alt={type} />
            </span>
          )}
        </Button>
      )}
    </OverlayTrigger>
  )
}

GenericTooltip.defaultProps = {
  placement: 'top',
  textAlign: 'center'
}

GenericTooltip.propTypes = {
  children: PropTypes.node,
  id: PropTypes.string.isRequired,
  placement: PropTypes.oneOf([
    'auto-start',
    'auto',
    'auto-end',
    'top-start',
    'top',
    'top-end',
    'right-start',
    'right',
    'right-end',
    'bottom-end',
    'bottom',
    'bottom-start',
    'left-end',
    'left',
    'left-start'
  ]),
  textAlign: PropTypes.oneOf(['right', 'left', 'center', 'justify']),
  text: PropTypes.node.isRequired,
  type: PropTypes.oneOf(['info']) // If there's new icon, add type here
}

export default GenericTooltip
